/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Vyberte velikost`
};

const da_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Vælg størrelse`
};

const de_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Größe auswählen`
};

const en_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Select a size`
};

const es_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Elegir una talla`
};

const fr_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Choisir une taille`
};

const hu_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Méret kiválasztása`
};

const it_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Scegli una taglia`
};

const nl_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Kies een maat`
};

const pl_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Wybierz rozmiar`
};

const pt_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Escolher um tamanho`
};

const sv_select_size = /** @type {(inputs: {}) => string} */ () => {
	return `Välj storlek`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const select_size = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.select_size(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("select_size", locale)
	if (locale === "cs") return cs_select_size(inputs)
	if (locale === "da") return da_select_size(inputs)
	if (locale === "de") return de_select_size(inputs)
	if (locale === "en") return en_select_size(inputs)
	if (locale === "es") return es_select_size(inputs)
	if (locale === "fr") return fr_select_size(inputs)
	if (locale === "hu") return hu_select_size(inputs)
	if (locale === "it") return it_select_size(inputs)
	if (locale === "nl") return nl_select_size(inputs)
	if (locale === "pl") return pl_select_size(inputs)
	if (locale === "pt") return pt_select_size(inputs)
	return sv_select_size(inputs)
};